export default __webpack_public_path__ + "static/media/check-reg.4748a8f8.png";